import BasicService from "./BasicService";

class ShopService extends BasicService {
  constructor() {
    super();
  }
  getAllShop() {
    let url = "/os";
    return this.axios.get(url,{
      params:{
        osType:"restaurant"
      }
    }).then(request => request.data);
  }
}

const shopService = new ShopService();
export default shopService;
